export const typography = {
  family: {
    primary: "'Inter', sans-serif",
  },
};
